import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconAudienceGoal = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zM6.5 7.8c0 .772-.628 1.4-1.4 1.4-.772 0-1.4-.628-1.4-1.4 0-.772.628-1.4 1.4-1.4.772 0 1.4.628 1.4 1.4zm9.8 0c0 .772-.628 1.4-1.4 1.4-.772 0-1.4-.628-1.4-1.4 0-.772.628-1.4 1.4-1.4.772 0 1.4.628 1.4 1.4zm-3.087 2.507c.254-.252.602-.407.987-.407h1.4c.772 0 1.4.628 1.4 1.4v.7a.7.7 0 01-.7.7h-1.444a3.2 3.2 0 00-1.643-2.393zM12.45 7.45A2.449 2.449 0 0110 9.9a2.449 2.449 0 01-2.45-2.45A2.449 2.449 0 0110 5a2.449 2.449 0 012.45 2.45zm-.952 3.15h.182a2.52 2.52 0 012.52 2.52v.63c0 .58-.47 1.05-1.05 1.05h-6.3c-.58 0-1.05-.47-1.05-1.05v-.63a2.52 2.52 0 012.52-2.52h.182c.457.219.96.35 1.498.35s1.043-.131 1.498-.35zM5.8 9.9c.385 0 .733.155.987.407A3.208 3.208 0 005.142 12.7H3.7A.7.7 0 013 12v-.7c0-.772.628-1.4 1.4-1.4h1.4z",
		fill: "currentColor"
	})
});
export default SvgIconAudienceGoal;
